import { jsx } from '@emotion/core';
import { circle, number, item, activeItem, awaitingItem } from './item.styles';
import { motion, AnimatePresence } from 'framer-motion';
import { COLORS } from '../../constants';

var getItemProgress = function getItemProgress(activeStep, index) {
  return {
    completed: activeStep > index + 1,
    active: activeStep === index + 1
  };
};

var checkVariants = {
  hidden: {
    opacity: 0,
    transition: {
      delay: 0.3
    }
  },
  visible: {
    opacity: 1
  }
};

var Check = function Check(_a) {
  var status = _a.status;
  return jsx(AnimatePresence, null, jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      transform: 'translateX(-1px)'
    },
    width: "16",
    height: "16"
  }, jsx(motion.path, {
    initial: "hidden",
    animate: status,
    variants: checkVariants,
    exit: "hidden",
    fill: "white",
    d: "M7.632 9.574l4.672-5.199a.935.935 0 1 1 1.392 1.25l-5.392 6a.935.935 0 0 1-1.412-.024L4.284 8.493a.935.935 0 1 1 1.432-1.202l1.916 2.283z"
  })));
};

export var Item = function Item(_a) {
  var children = _a.children,
      _b = _a.index,
      index = _b === void 0 ? 0 : _b,
      _c = _a.activeStep,
      activeStep = _c === void 0 ? 0 : _c;

  var _d = getItemProgress(activeStep, index),
      active = _d.active,
      completed = _d.completed;

  var itemStyle = [item];
  var numberStyle = [circle, number];

  if (active) {
    itemStyle.push(activeItem);
  } else {
    itemStyle.push(awaitingItem);
  }

  var itemVariants = {
    hidden: {
      opacity: 0,
      color: COLORS.grays.darkest
    },
    completed: {
      opacity: 1,
      color: COLORS.grays.darkest
    },
    active: {
      opacity: 1,
      color: COLORS.grays.darkest,
      transition: {
        delay: 0.3
      }
    },
    awaiting: {
      color: COLORS.grays.light,
      opacity: 1
    }
  };
  var numberVariants = {
    hidden: {
      opacity: 0,
      borderColor: COLORS.grays.light,
      backgroundColor: COLORS.white,
      color: COLORS.grays.light
    },
    completed: {
      opacity: 1,
      borderColor: COLORS.blues.primary,
      backgroundColor: COLORS.blues.primary
    },
    active: {
      opacity: 1,
      borderColor: COLORS.blues.primary,
      backgroundColor: COLORS.white,
      color: COLORS.blues.primary,
      transition: {
        when: 'beforeChildren',
        delay: 0.3
      }
    },
    awaiting: {
      opacity: 1,
      borderColor: COLORS.grays.light,
      backgroundColor: COLORS.white,
      color: COLORS.grays.light
    }
  };
  return jsx(motion.li, {
    initial: "hidden",
    animate: active ? 'active' : completed ? 'completed' : 'awaiting',
    variants: itemVariants,
    css: itemStyle,
    "aria-current": active ? 'true' : 'false'
  }, jsx(motion.span, {
    variants: numberVariants,
    css: numberStyle
  }, completed ? jsx(Check, {
    status: completed ? 'visible' : 'hidden'
  }) : index + 1), children);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Stepper/item.js
// module id = 1237
// module chunks = 0